import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../utilities/onDocumentReady';

const indexPopularSliders = [];

const createSlider = (tab) => {
    if (indexPopularSliders[tab] !== undefined) {
        return false;
    }
    indexPopularSliders[tab] = new Swiper(`.index-popular-tab--${tab} .index-popular-slider__container`, {
        speed: 600,
        spaceBetween: 12,
        slidesPerView: 4,
        slidesPerGroup: 4,
        slideClass: 'index-popular-slider__slide',
        noSwiping: true,
        noSwipingClass: 'ui-product-preview-slider__slide',
        autoHeight: true,
        pagination: {
            el: `.index-popular-tab--${tab} .index-popular-control__pagination`,
            type: 'fraction',
        },
        navigation: {
            nextEl: `.index-popular-tab--${tab} .index-popular-control__button--next`,
            prevEl: `.index-popular-tab--${tab} .index-popular-control__button--prev`
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            1023: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1444: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        },
    });

    return true;
};

const activateSlider = ($tabsItem) => {
    if ($tabsItem.hasClass('index-popular-tabs__item--active')) {
        return false;
    }
    const tab = $tabsItem.attr('data-tab');

    // switch buttons
    $('.index-popular-tabs__item').removeClass('index-popular-tabs__item--active');
    $tabsItem.addClass('index-popular-tabs__item--active');

    // switch tabs
    $('.index-popular-tab').hide();
    $(`.index-popular-tab--${tab}`).fadeIn();

    // switch select
    $tabsItem.parent('.index-popular-tabs-select').slideToggle(200).siblings('.index-popular-select__value')
        .text($tabsItem.text());

    // slider
    if (!indexPopularSliders[tab]) {
        createSlider(tab);
    }

    // catalog button
    $('.index-popular__catalog-button').attr('href', `/catalog/?compilation=${tab}`);

    $('.index-popular-tab[style*="display: block"]').find('.ui-product-preview-slider__container').removeClass('swiper-container--initialized');
    $('.ui-product').trigger('render');

    $('.ui-product').trigger('render');
    return true;
};

$('.index-popular-tabs__item').click(function (e) {
    e.stopPropagation();
    activateSlider($(this));
});


$('.index-popular-select__value').click(function () {
    $(this).siblings('.index-popular-tabs-select').slideToggle(200);
});

activateSlider($('.index-popular-tabs__item').first());

if ($(window).width() < 768) {
    $('.index-popular-tabs-select .index-popular-tabs__item').first().click();
}


